import {Pipe, PipeTransform} from '@angular/core';
import {EventDetailsType} from '../../domain/event/event';
import {ChargeRecordDto} from '../../domain/chargeRecord/chargeRecordDto';

@Pipe({
    name: 'asChargeRecord'
})
export class ChargeRecordPipe implements PipeTransform {

    constructor() {
    }

    transform(event: EventDetailsType): ChargeRecordDto {
        return event as ChargeRecordDto;
    }
}
